import usePagePermission from "app/hooks/usePagePermission";
import { deleteMenu } from "app/services/menuService";
import Tooltip from "rc-tooltip";
import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import {
  FaInfo,
  FaInfoCircle,
  FaPlus,
  FaTimes,
  FaTrashAlt,
} from "react-icons/fa";

function DeletePopOver({
  id,
  setDeleteTarget,
  setIsDeleteShow,
  isDeleteShow,
  setMenuState,
  parent,
  type,
}) {
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();
  //console.log({ canView, canAdd, canEdit, canDelete });

  const [isLoading, setIsLoading] = useState(false);

  const deleteHandler = async () => {
    setIsLoading(true);
    const deleteData = await deleteMenu(id, type);
    setIsLoading(false);

    setIsDeleteShow(false);
    setMenuState(deleteData.data);
  };
  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      show={isDeleteShow}
      overlay={
        <Popover id="popover-basic" style={{ width: 300, zIndex: 500 }}>
          <Popover.Body>
            <div className="d-flex justify-content-center">
              <p className="font-weight-bold">
                Are you sure to delete this menu?
              </p>
            </div>

            <div className="d-flex justify-content-center">
              {parent && (
                <p className="text-danger">Child menus will be deleted</p>
              )}
            </div>

            <input type="hidden" value={id} name="id" />
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-sm btn-outline-danger mx-1"
                onClick={() => {
                  setIsDeleteShow(false);
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={isLoading}
                onClick={() => deleteHandler(id)}
              >
                Delete
              </button>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      {canEdit ? (
        <Tooltip placement="top" overlay={<span>Delete Menu</span>}>
          <button
            className="btn btn-link btn-sm"
            type="button"
            onClick={(e) => {
              setDeleteTarget(e.target);
              setIsDeleteShow(true);
            }}
          >
            <FaTrashAlt />
          </button>
        </Tooltip>
      ) : (
        <></>
      )}
    </OverlayTrigger>
  );
}

export default DeletePopOver;
